export default function (ModalService) {
    return function (vehicleId, keepers, keeper, dealers) {
        return ModalService.showModal({
            controller: require('../../controllers/createLetter/createLetterCtrl'),
            template: require('../../controllers/createLetter/create-letter.html'),
            inputs: {
                vehicleId,
                keepers,
                keeper,
                dealers
            }
        });
    };
}



// WEBPACK FOOTER //
// ./Client/app/tasks/services/createLetter/openCreateLetterModal.js